
import Vue from 'vue'
import jsPDf from 'jspdf'
import vPage from 'v-page'
import VueCarousel from 'vue-carousel'
import BlockUI from 'vue-blockui'
import App from './App.vue'
import loadingImage from './assets/logo.png'


setTimeout(() => {
  
  new Vue({
    el: '#app',
    render: h => h(App),
  })
}, 1000);

Vue.use(vPage);
Vue.use(VueCarousel);
Vue.use(BlockUI);


// WEBPACK FOOTER //
// ./src/main.js